export enum StatusUserGroupEnum {
	Active = 1,
	Suspended = 2,
}
